// extracted by mini-css-extract-plugin
module.exports = {"microsoftAdsRow":"fD-z","microsoftAdsCard":"gD-z"};